import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as result from '../result'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: result.RESOURCE.payload.dimension.partialId,
      partialId: result.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'When the latest deployment finished; null until the pull request is merged and deployed.',
    isOptional: true,
    name: 'Deployed At',
    partialId: PartialId.Standard.create('deployed_at'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
